import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let EDocumentWritebackStatus;
(function (EDocumentWritebackStatus) {
  EDocumentWritebackStatus["Success"] = "success";
  EDocumentWritebackStatus["Failure"] = "failure";
  EDocumentWritebackStatus["Pending"] = "pending";
})(EDocumentWritebackStatus || (EDocumentWritebackStatus = {}));
export let EReviewStatus;
(function (EReviewStatus) {
  EReviewStatus["InProcess"] = "in-process";
  EReviewStatus["NeedsReview"] = "needs-review";
  EReviewStatus["NeedsSplitting"] = "needs-splitting";
  EReviewStatus["SplitCompleted"] = "split-completed";
  EReviewStatus["ReferralCreated"] = "referral-created";
  EReviewStatus["Approved"] = "approved";
  EReviewStatus["Rejected"] = "rejected";
  EReviewStatus["Skipped"] = "skipped";
  EReviewStatus["Archived"] = "archived";
})(EReviewStatus || (EReviewStatus = {}));
export let EProcessingStep;
(function (EProcessingStep) {
  EProcessingStep["NeedsSplitting"] = "needs-splitting";
  EProcessingStep["NeedsExtraction"] = "needs-extraction";
  EProcessingStep["ExtractedData"] = "extracted-data";
  EProcessingStep["Completed"] = "completed";
})(EProcessingStep || (EProcessingStep = {}));
export let EDataExtractionStatus;
(function (EDataExtractionStatus) {
  EDataExtractionStatus["Skipped"] = "skipped";
  EDataExtractionStatus["Success"] = "success";
})(EDataExtractionStatus || (EDataExtractionStatus = {}));
export let EEhrFileReviewStatus;
(function (EEhrFileReviewStatus) {
  EEhrFileReviewStatus["Reviewed"] = "reviewed";
  EEhrFileReviewStatus["Unreviewed"] = "unreviewed";
})(EEhrFileReviewStatus || (EEhrFileReviewStatus = {}));
export let EPriority;
(function (EPriority) {
  EPriority["High"] = "high";
  EPriority["Urgent"] = "urgent";
  EPriority["Low"] = "low";
  EPriority["Unknown"] = "unknown";
})(EPriority || (EPriority = {}));
export let EAuthorizationStatus;
(function (EAuthorizationStatus) {
  EAuthorizationStatus["Approved"] = "approved";
  EAuthorizationStatus["Denied"] = "denied";
})(EAuthorizationStatus || (EAuthorizationStatus = {}));
export let EFaxDocumentType;
(function (EFaxDocumentType) {
  EFaxDocumentType["AdvancedDirective"] = "advanced-directive";
  EFaxDocumentType["AuthorizationRequest"] = "authorization-request";
  EFaxDocumentType["BillingForm"] = "billing-form";
  EFaxDocumentType["ComplianceReport"] = "compliance-report";
  EFaxDocumentType["ControlledSubstanceAgreement"] = "controlled-substance-agreement";
  EFaxDocumentType["DiagnosticTesting"] = "diagnostic-testing";
  EFaxDocumentType["HospitalNote"] = "hospital-note";
  EFaxDocumentType["ImplantForm"] = "implant-form";
  EFaxDocumentType["InfusionDocument"] = "infusion-document";
  EFaxDocumentType["Labs"] = "labs";
  EFaxDocumentType["MultiCategory"] = "multi-category";
  EFaxDocumentType["OfficeNote"] = "office-note";
  EFaxDocumentType["Order"] = "order";
  EFaxDocumentType["Other"] = "other";
  EFaxDocumentType["OtherForm"] = "other-form";
  EFaxDocumentType["PolicyForm"] = "policy-form";
  EFaxDocumentType["RecordRelease"] = "record-release";
  EFaxDocumentType["Referral"] = "referral";
})(EFaxDocumentType || (EFaxDocumentType = {}));
export let EFaxDocumentSubType;
(function (EFaxDocumentSubType) {
  EFaxDocumentSubType["CustodyPaperwork"] = "custody-paperwork";
  EFaxDocumentSubType["HealthCareProxy"] = "health-care-proxy";
  EFaxDocumentSubType["DeathCertificate"] = "death-certificate";
  EFaxDocumentSubType["GuardianshipPapers"] = "guardianship-papers";
  EFaxDocumentSubType["PowerOfAttorney"] = "power-of-attorney";
  EFaxDocumentSubType["MedicationPriorAuthorizationRequest"] = "medication-prior-authorization-request";
  EFaxDocumentSubType["MedicationPriorAuthorizationResponse"] = "medication-prior-authorization-response";
  EFaxDocumentSubType["MedicationAdditionalInformationNeeded"] = "medication-additional-information-needed";
  EFaxDocumentSubType["DrugUtilizationReview"] = "drug-utilization-review";
  EFaxDocumentSubType["DrugInteraction"] = "drug-interaction";
  EFaxDocumentSubType["DrugRecall"] = "drug-recall";
  EFaxDocumentSubType["LabPriorAuthorizationResponse"] = "lab-diagnostic-testing-prior-authorizations-response";
  EFaxDocumentSubType["LabPriorAuthorizationRequest"] = "lab-diagnostic-testing-prior-authorizations-request";
  EFaxDocumentSubType["LabAdditionalInfoNeeded"] = "lab-diagnostic-testing-additional-info-needed";
  EFaxDocumentSubType["WeighlossQuestionnaireWithMedicationPriorAuthorizationRequest"] = "weighloss-questionnaire-with-medication-prior-authorization-request";
  EFaxDocumentSubType["DrugAssistanceProgram"] = "drug-assistance-program";
  EFaxDocumentSubType["CopayAssistance"] = "copay-assistance";
  EFaxDocumentSubType["MedicalNecessity"] = "medical-necessity";
  EFaxDocumentSubType["ABN"] = "abn";
  EFaxDocumentSubType["Collections"] = "collections";
  EFaxDocumentSubType["CreditCardSale"] = "credit-card-sale";
  EFaxDocumentSubType["FinancialAssistanceProgram"] = "financial-assistance-program";
  EFaxDocumentSubType["PaymentPlan"] = "payment-plan";
  EFaxDocumentSubType["QuickRemitNotification"] = "quick-remit-notification";
  EFaxDocumentSubType["CPAPComplianceReport"] = "cpap-compliance-report";
  EFaxDocumentSubType["ControlledSubstanceAgreement"] = "controlled-substance-agreement";
  EFaxDocumentSubType["Echo"] = "echo";
  EFaxDocumentSubType["EEG"] = "eeg";
  EFaxDocumentSubType["HolterMonitor"] = "holter-monitor";
  EFaxDocumentSubType["HeartMonitor"] = "heart-monitor";
  EFaxDocumentSubType["LoopRecorder"] = "loop-recorder";
  EFaxDocumentSubType["EKG"] = "ekg";
  EFaxDocumentSubType["EMG"] = "emg";
  EFaxDocumentSubType["Neuropysch"] = "neuropysch";
  EFaxDocumentSubType["DEXABoneDensity"] = "dexa-bone-density";
  EFaxDocumentSubType["Mammogram"] = "mammogram";
  EFaxDocumentSubType["XRay"] = "x-ray";
  EFaxDocumentSubType["Ultrasound"] = "ultrasound";
  EFaxDocumentSubType["CT"] = "ct";
  EFaxDocumentSubType["CTA"] = "cta";
  EFaxDocumentSubType["MRI"] = "mri";
  EFaxDocumentSubType["MRA"] = "mra";
  EFaxDocumentSubType["PET"] = "pet";
  EFaxDocumentSubType["SPECT"] = "spect";
  EFaxDocumentSubType["VNG"] = "vng";
  EFaxDocumentSubType["ENG"] = "eng";
  EFaxDocumentSubType["Posturography"] = "posturography";
  EFaxDocumentSubType["Audiogram"] = "audiogram";
  EFaxDocumentSubType["HearingTest"] = "hearing-test";
  EFaxDocumentSubType["OpticalCoherenceTomography"] = "optical-coherence-tomography";
  EFaxDocumentSubType["VisualEvokedResponse"] = "visual-evoked-response";
  EFaxDocumentSubType["SleepStudies"] = "sleep-studies";
  EFaxDocumentSubType["EDNotes"] = "ed-notes";
  EFaxDocumentSubType["InpatientConsult"] = "inpatient-consult";
  EFaxDocumentSubType["ProgressNotes"] = "progress-notes";
  EFaxDocumentSubType["SocialWorkScreenings"] = "social-work-screenings";
  EFaxDocumentSubType["NutritionConsultation"] = "nutrition-consultation";
  EFaxDocumentSubType["HistoryAndPhysicals"] = "history-and-physicals";
  EFaxDocumentSubType["DischargeSummary"] = "discharge-summary";
  EFaxDocumentSubType["ImagingDocumentsImplant"] = "imaging-documents-implants";
  EFaxDocumentSubType["SpecialtyPharmacyDocuments"] = "specialty-pharmacy-documents";
  EFaxDocumentSubType["InfusionOrder"] = "infusion-order";
  EFaxDocumentSubType["PPDResults"] = "ppd-results";
  EFaxDocumentSubType["AnyBloodwork"] = "any-bloodwork";
  EFaxDocumentSubType["PathologyReport"] = "pathology-report";
  EFaxDocumentSubType["BiopsyResult"] = "biopsy-result";
  EFaxDocumentSubType["GeneticTesting"] = "genetic-testing";
  EFaxDocumentSubType["CerebralSpinalFluid"] = "cerebral-spinal-fluid";
  EFaxDocumentSubType["ESAConsent"] = "esa-consent";
  EFaxDocumentSubType["Urinalysis"] = "urinalysis";
  EFaxDocumentSubType["DrugTesting"] = "drug-testing";
  EFaxDocumentSubType["PrimaryCareOfficeNotes"] = "primary-care-office-notes";
  EFaxDocumentSubType["OutpatientSpecialtyClinicNotes"] = "outpatient-specialty-clinic-notes";
  EFaxDocumentSubType["Imaging"] = "imaging";
  EFaxDocumentSubType["SleepStudyOrder"] = "sleep-study-order";
  EFaxDocumentSubType["CPAPOrder"] = "cpap-order";
  EFaxDocumentSubType["DMEOrder"] = "dme-order";
  EFaxDocumentSubType["MedicationRefillsRequest"] = "medication-refills-request";
  EFaxDocumentSubType["PTScript"] = "pt-script";
  EFaxDocumentSubType["OTScript"] = "ot-script";
  EFaxDocumentSubType["SLPScript"] = "slp-script";
  EFaxDocumentSubType["VNAOrders"] = "vna-orders";
  EFaxDocumentSubType["VerbalOrderForm"] = "verbal-order-form";
  EFaxDocumentSubType["PatientDemographics"] = "patient-demographics";
  EFaxDocumentSubType["ComplianceReports"] = "compliance-reports";
  EFaxDocumentSubType["CurrentMedicationSheet"] = "current-medication-sheet";
  EFaxDocumentSubType["RecordsSentBack"] = "records-sent-back";
  EFaxDocumentSubType["ResponseToRequestForRecords"] = "response-to-request-for-records";
  EFaxDocumentSubType["CoverPage"] = "cover-page";
  EFaxDocumentSubType["FMLA"] = "fmla";
  EFaxDocumentSubType["MedicalExpenseVerifications"] = "medical-expense-verification";
  EFaxDocumentSubType["SchoolForm"] = "school-form";
  EFaxDocumentSubType["DisabilityForm"] = "disability-form";
  EFaxDocumentSubType["LifeInsurance"] = "life-insurance";
  EFaxDocumentSubType["LongShortTermDiasbility"] = "long-short-term-disability";
  EFaxDocumentSubType["PracticePolicies"] = "practice-policies";
  EFaxDocumentSubType["DriversLicense"] = "drivers-license";
  EFaxDocumentSubType["InsuranceCard"] = "insurance-card";
  EFaxDocumentSubType["HIPAAForms"] = "hipaa-forms";
  EFaxDocumentSubType["WorkersComp"] = "workers-comp";
  EFaxDocumentSubType["NoFault"] = "no-fault";
  EFaxDocumentSubType["RecordsRequest"] = "records-request";
  EFaxDocumentSubType["Subpeonas"] = "subpeonas";
  EFaxDocumentSubType["Audits"] = "audits";
  EFaxDocumentSubType["OPMC"] = "opmc";
  EFaxDocumentSubType["ChartReview"] = "chart-review";
  EFaxDocumentSubType["Depositions"] = "depositions";
  EFaxDocumentSubType["DisabilityRequest"] = "disability-request";
})(EFaxDocumentSubType || (EFaxDocumentSubType = {}));
export const fieldsFaxDocument = _extends({}, fieldsIBaseModel, {
  currentProcessingStep: {
    type: 'Option',
    values: EProcessingStep
  },
  dataExtractionResults: {
    type: 'Object'
  },
  ehrAssignee: {
    type: 'ID',
    ref: EModel.User
  },
  ehrFileReviewStatus: {
    type: 'Option',
    values: EEhrFileReviewStatus
  },
  extractedData: {
    type: 'Object'
  },
  facility: {
    type: 'ID',
    ref: EModel.Facility
  },
  faxDocumentCategory: {
    type: 'ID',
    ref: EModel.FaxDocumentCategory
  },
  faxDocumentWorkflowActionResults: {
    type: 'Object',
    array: true
  },
  fieldsUpdatedByUser: {
    type: 'Unknown'
  },
  integratorCreationResults: {
    type: 'Object'
  },
  largeLanguageModelRequest: {
    type: 'ID',
    ref: EModel.LargeLanguageModelRequest
  },
  originalFileName: {
    type: 'Text'
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  processedDocument: {
    type: 'ID',
    ref: EModel.FileUpload
  },
  processedFileName: {
    type: 'Text'
  },
  provider: {
    type: 'ID',
    ref: EModel.Provider
  },
  rawDocument: {
    type: 'ID',
    ref: EModel.FileUpload
  },
  referral: {
    type: 'ID',
    ref: EModel.Referral
  },
  reviewedBy: {
    type: 'ID',
    ref: EModel.User
  },
  reviewStatus: {
    type: 'Option',
    values: EReviewStatus
  },
  stats: {
    type: 'Object'
  }
});